module.exports = __webpack_public_path__ + "static/media/beijing.acc18570.png";